import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "signup": "Sign Up",
      "signin": "Sign In",
      "signin-already-have-account": "Already have an account?",
      "signin-with-google": "Sign In with Google",
      "signin-no-account": "No Account?",
      "signin-forgot-password": "Forgot Password?",
      "update-profile": "Update Profile",
      "become-tourguide": "Become a Guide",
      "search-go": "Go!",
      "search-random": "Random",
      "search-placeholder": "Search Destinations",

      "home": "Home",
      "dashboard": "Dashboard",
      "admin": "Admin",
      "logout": "Logout",
      "loading": "Loading...",
      "cancel": "Cancel",
      "delete": "Delete",
      "edit": "Edit",
      "close": "Close",
      "create": "Create",
      "search": "Search",
      "play": "Play",
      "pause": "Pause",
      "previous": "Previous",
      "next": "Next",
      "duration": "duration",
      "text": "Text",
      "by": "By {{name}}",
      "hours-label": "hours",
      "valid-url-error": "Please enter a valid URL",
      "valid-email-error": "Please enter a valid email address",
      "email-not-valid": "Email is not valid",
      "phone-valid-error": "Please enter a valid phone number.",
      "password-empty-error": "Password can not be empty.",
      "phone-number": "Phone Number",
      "email": "email",
      "password": "password",
      "enter-phone-number": "enter phone number",
      "enter-email": "enter email",
      "enter-password": "enter password",
      "enter-email-placeholder": "Enter email",
      "forgot-password": "Forgot Password",
      "reset-password": "Reset Password",
      "reset-password-for": "Enter New Password for",
      "enter-new-password": "Enter new password",
      "enter-new-password-aria": "enter new password",
      "images": "Images",
      "upload-images-help": "Upload images (5MB Max)",
      "image-type-error": "Please select an image file (jpeg, png, or gif)",
      "image-size-error": "Please select a smaller file (less than 5MB)",
      "preview": "preview",
      "notfound-message": "The page you are looking for does not exist. Perhaps you'd like to play with this clicker button?",
      "click-me": "Click me",
      "clicked-times": "You clicked {{count}} times",
      "or-go-home": "Or, you can always go",
      "error-user-exists": "So sorry! This user already exists, please use a different email address or",
      "error-sign-in-link": "sign in!",
      "error-reset-bad-token": "Sorry, this password reset token is invalid. Please try to reset your password again.",
      "error-login-bad-credentials": "Sorry, your email or password is incorrect. Please try again.",
      "error-reset-password-link-prefix": "If you forgot your password, you can",
      "error-reset-password-link": "reset your password here.",
      "message-password-reset": "If you have entered a valid email, password reset instructions have been sent to your email! Please check your email and follow the instructions.",
      "message-password-reset-success": "Your password has been reset! Please sign in with your new password.",
      "signing-in-google": "Signing in with Google...",
      "toggle-navigation": "Toggle navigation",
      "select-language": "Select language",
      "user-menu": "User menu",

      "home-hero-title": "Your local adventure awaits",
      "home-hero-subtitle": "Discover location-based audio tours created by independent guides",
      "home-signup-ad": "Join as a guide, publish audio tours with pinned stops, and earn royalties as listeners explore.",

      "search-where": "Where",
      "search-destinations": "Search destinations",
      "search-city-placeholder": "Search for a city...",

      "stops-count": "{{count}} stops",
      "stops-count_one": "{{count}} stop",
      "stops-count_other": "{{count}} stops",
      "tours-count_one": "{{count}} tour",
      "tours-count_other": "{{count}} tours",
      "stops-label": "stops",
      "tours-label": "tours",
      "radius-label": "radius",
      "text-tour": "Text tour",
      "text-stop": "Text stop",
      "no-audio-yet": "No audio yet",
      "unknown-stop": "Unknown Stop",
      "unknown-tour": "Unknown Tour",
      "stop-x-of-y": "Stop {{current}} of {{total}}",

      "location-experiences-guided-tours": "Available Tours",
      "location-no-experiences": "No tours available at this location yet. Check back soon!",
      "location-no-information": "Location not found. Please try another destination.",
      "location-experiences-in": "Experiences in {{location}}",
      "location-tours-available": "{{count}} tours available",
      "location-tours-available_one": "{{count}} tour available",
      "location-tours-available_other": "{{count}} tours available",
      "location-audio-tours-note": "Location-based audio tours (no dates or group sizes).",
      "location-no-tours-found": "No tours found",
      "location-empty-description": "There are no tours available in this location yet. Check back soon!",
      "location-become-guide-here": "Become a Guide Here",

      "map-explore-nearby": "Explore nearby",
      "map-audio-tours-around-you": "Audio tours around you",
      "map-no-audio-tours": "No audio tours here yet",
      "map-empty-description": "Search another city or create the first tour for this area.",
      "map-start-tour": "Start a tour",
      "map-view-on-map": "View on map",
      "map-view-on-map-arrow": "View on map ->",
      "map-zoom-in": "Zoom in",
      "map-zoom-out": "Zoom out",
      "map-drag-to-reposition": "{{title}} (drag to reposition)",
      "map-km-away": "{{distance}}km away",
      "map-stop-number": "Stop {{number}}",
      "map-thumbs-up": "Thumbs up",
      "map-signin-rate": "Sign in to rate",
      "map-view-tour": "View tour",
      "map-loading-tracks": "Loading tracks...",
      "map-pin-save-error": "Failed to save pin location. Please try again.",

      "audio-previous-stop": "Previous stop",
      "audio-next-stop": "Next stop",
      "audio-seek": "Seek",

      "comments-title": "Comments",
      "comments-load-error": "Could not load comments.",
      "comments-post-error": "Could not post comment. Please try again.",
      "comments-just-now": "just now",
      "comments-minutes-ago": "{{count}}m ago",
      "comments-hours-ago": "{{count}}h ago",
      "comments-days-ago": "{{count}}d ago",
      "comments-placeholder": "Share your thoughts about this stop...",
      "comments-posting": "Posting...",
      "comments-post": "Post",
      "comments-signin": "Sign in to leave a comment",
      "comments-loading": "Loading comments...",
      "comments-empty": "No comments yet.",
      "comments-be-first": " Be the first!",

      "tourguide-get-started": "Create Your Guide Profile",
      "tourguide-get-started-paragraph": "Set up your profile to start publishing audio tours and connecting with listeners.",
      "tourguide-create-guide-profile": "Get Started",
      "tourguide-dashboard": "Dashboard",
      "tourguide-my-tours": "My Tours",
      "tourguide-schedule": "Schedule",
      "tourguide-profile": "Profile",
      "tourguide-create-tour": "Create Tour",
      "tourguide-no-tours": "You haven't created any tours yet. Start by creating your first tour!",

      "guide-edit-profile": "Edit Profile",
      "guide-create-first-tour": "Create Your First Tour",
      "guide-edit-your-profile": "Edit Your Profile",
      "guide-create-profile": "Create Your Guide Profile",
      "guide-update-info-subtitle": "Update your information to attract more visitors",
      "guide-create-info-subtitle": "Set up your profile to start offering tours",
      "guide-profile-photo": "Profile Photo",
      "guide-map-pin": "Map Pin",
      "guide-color": "Color",
      "guide-emoji": "Emoji",
      "guide-pin-color-aria": "Pin color {{color}}",
      "guide-pin-emoji-aria": "Pin emoji {{emoji}}",
      "guide-name": "Guide Name",
      "guide-name-placeholder": "Your name or business name",
      "guide-name-help": "This is how visitors will identify you",
      "guide-location": "Location",
      "guide-location-placeholder": "Select your location",
      "guide-location-missing": "Don't see your location?",
      "guide-contact-us": "Contact us",
      "guide-languages-spoken": "Languages Spoken",
      "guide-bio": "Bio",
      "guide-bio-placeholder": "Tell visitors about yourself, your experience, and what makes your tours special...",
      "guide-contact-info": "Contact Information",
      "guide-contact-info-help": "Add at least one way for visitors to reach you. This information will be visible on your public profile.",
      "guide-website": "Website",
      "guide-save-profile": "Save Profile",
      "guide-contact-via": "Contact via:",
      "guide-name-required": "Please enter your name or business name",
      "guide-bio-required": "Tell visitors about yourself and your tours",
      "guide-location-required": "Please select your location",
      "guide-language-required": "Please select at least one language",
      "guide-contact-required": "Please add at least one way for visitors to contact you",

      "language-english": "English",
      "language-spanish": "Spanish",
      "language-french": "French",
      "language-german": "German",
      "language-italian": "Italian",
      "language-portuguese": "Portuguese",
      "language-chinese": "Mandarin Chinese",
      "language-russian": "Russian",
      "language-korean": "Korean",
      "language-japanese": "Japanese",
      "language-arabic": "Arabic",
      "language-hebrew": "Hebrew",

      "category-general": "General",
      "category-ghost-tour": "Ghost Tour",
      "category-historical": "Historical",
      "category-pop-culture": "Pop Culture",
      "category-family-history": "Family History",
      "category-food-drink": "Food & Drink",
      "category-architecture": "Architecture",
      "category-nature-parks": "Nature & Parks",
      "category-art-culture": "Art & Culture",

      "tour-title": "Tour Title",
      "tour-description": "Description",
      "tour-duration": "Duration (hours)",
      "tour-cost": "Price",
      "tour-cost-type": "Pricing Type",
      "tour-max-size": "Max Group Size",
      "tour-per-person": "Per Person",
      "tour-per-tour": "Per Tour",
      "tour-create": "Create Tour",
      "tour-update": "Save Changes",
      "tour-delete": "Delete Tour",
      "tour-schedule": "Schedule Dates",
      "tour-edit": "Edit Tour",
      "tour-create-new": "Create New Tour",
      "tour-editor-subtitle-edit": "Fill in the details below to update your tour",
      "tour-editor-subtitle-create": "Fill in the details below to create a new tour",
      "tour-images": "Tour Images",
      "tour-title-placeholder": "e.g., Hidden Gems Audio Tour",
      "tour-description-placeholder": "Describe your tour experience, what visitors will see and do...",
      "tour-category": "Category",
      "tour-privacy-level": "Privacy Level",
      "tour-public": "Public",
      "tour-private": "Private",
      "tour-unlisted": "Unlisted",
      "tour-public-description": "Visible to everyone on the map",
      "tour-private-description": "Only visible to people you share with",
      "tour-unlisted-description": "Hidden from map, accessible via link",
      "tour-manage-sharing": "Manage Sharing",
      "tour-delete-confirm-title": "Delete Tour?",
      "tour-delete-confirm-message": "This action cannot be undone. Are you sure you want to delete this tour?",
      "tour-title-required": "Title is required",
      "tour-description-required": "Description is required",
      "tour-about-this-tour": "About This Tour",
      "tour-stops": "Stops",
      "tour-play-from-start": "Play from start",
      "tour-sign-in-to-listen": "Sign in to listen",
      "tour-loading-stops": "Loading stops...",
      "tour-no-stops-yet": "No stops yet.",
      "tour-guide": "Guide",
      "tour-start-listening": "Start listening",
      "tour-stops-ready-on-map": "{{count}} stops ready on the map",
      "tour-stops-ready-on-map_one": "{{count}} stop ready on the map",
      "tour-stops-ready-on-map_other": "{{count}} stops ready on the map",
      "tour-open-first-stop-map": "Open first stop on map",

      "track-tour-stops": "Tour Stops",
      "track-add-stop": "Add Stop",
      "track-edit-stop": "Edit Stop",
      "track-view-on-map": "View on map",
      "track-empty": "No stops yet. Click on the map to drop a pin and add your first stop!",
      "track-delete-title": "Delete Stop?",
      "track-delete-message": "This will permanently delete this tour stop. This action cannot be undone.",
      "track-delete-stop": "Delete Stop",
      "track-audio-file": "Audio File",
      "track-audio-file-optional": "Audio File (Optional)",
      "track-stop-title": "Stop Title *",
      "track-stop-title-placeholder": "e.g., Welcome",
      "track-description": "Description",
      "track-description-placeholder": "Describe what visitors will hear at this location...",
      "track-text-content": "Text Content",
      "track-text-content-placeholder": "Optional script or text-only stop content...",
      "track-stop-location": "Stop Location *",
      "track-location-help": "Click the map to drop a pin for this stop. You can also drag the pin to fine-tune the location.",
      "track-latitude": "Latitude *",
      "track-longitude": "Longitude *",
      "track-sequence-order": "Sequence Order",
      "track-sequence-help-zero": "Order in which this stop appears in the tour (0 = first)",
      "track-sequence-help-one": "Order of this stop in the tour (1 = first)",
      "track-uploading": "Uploading...",
      "track-saving": "Saving...",
      "track-update-stop": "Update Stop",
      "track-duration": "Duration:",
      "track-additional-notes": "Additional Notes",
      "track-additional-notes-placeholder": "Any additional notes (optional)",
      "track-provide-content-help": "Provide either text content or audio (or both)",
      "track-tour": "Tour *",
      "track-select-tour-placeholder": "Select a tour...",
      "track-create-new-tour": "+ Create New Tour",
      "track-new-tour-title": "New Tour Title *",
      "track-new-tour-description": "New Tour Description",
      "track-tour-title-placeholder": "Tour title",
      "track-new-tour-description-placeholder": "Tour description (optional)",
      "track-create-tour": "Create Tour",
      "track-location": "Location",
      "track-title": "Title *",
      "track-title-placeholder": "Stop title",
      "track-text-content-full-placeholder": "Type what you want to say at this stop...",
      "track-error-select-audio": "Please select an audio file (MP3, M4A, WAV, etc.)",
      "track-error-audio-duration": "Could not read audio file duration",
      "track-error-title-required": "Title is required",
      "track-error-valid-latitude": "Valid latitude required (-90 to 90)",
      "track-error-valid-longitude": "Valid longitude required (-180 to 180)",
      "track-error-audio-or-text": "Add an audio file or text content",
      "track-error-text-or-audio": "Add text content or an audio file",
      "track-error-sequence": "Sequence must be 0 or greater",
      "track-error-get-upload-url": "Failed to get upload URL",
      "track-error-upload-audio": "Failed to upload audio file",
      "track-error-create-stop": "Failed to create stop",
      "track-error-update-stop": "Failed to update stop",
      "track-error-save-stop": "Could not save stop",
      "track-error-read-audio-file": "Could not read audio file. Please try a different file.",
      "track-error-enter-tour-title": "Please enter a tour title",
      "track-error-create-tour": "Failed to create tour",
      "track-error-select-tour": "Please select a tour or create a new one",
      "track-error-title": "Please enter a title",
      "track-error-content": "Please provide either audio or text content",
      "track-error-duration": "Could not read the audio duration. Please choose a different audio file.",
      "track-error-upload-track": "Failed to upload track. Please try again.",

      "sharing-title": "Manage Tour Sharing",
      "sharing-info": "Share this private tour with specific users by entering their email address. They'll be able to view and stream the tour once shared.",
      "sharing-user-email": "User Email",
      "sharing": "Sharing...",
      "share": "Share",
      "sharing-shared-with": "Shared With ({{count}})",
      "sharing-empty": "This tour hasn't been shared with anyone yet.",
      "sharing-date": "Shared {{date}}",
      "sharing-remove-access": "Remove access",
      "sharing-remove": "Remove",

      "schedule-title": "Schedule Tour",
      "schedule-add-date": "Add Date",
      "schedule-date": "Date & Time",
      "schedule-capacity": "Available Spots",
      "schedule-no-dates": "No dates scheduled yet. Add your first available date!",
      "schedule-add-new-date": "Add New Date",
      "schedule-date-only": "Date",
      "schedule-time": "Time",
      "schedule-upcoming-dates": "Upcoming Dates",
      "schedule-past-dates": "Past Dates",
      "schedule-booked": "{{booked}} / {{capacity}} booked",
      "schedule-attended": "{{booked}} / {{capacity}} attended",
      "schedule-delete-date": "Delete this date",
      "schedule-select-date-error": "Please select a date",
      "schedule-future-date-error": "Please select a future date and time",
      "schedule-tour-fallback": "Tour",

      "brochure-share-world": "Share Your World",
      "brochure-subtitle": "Turn your local knowledge into unforgettable experiences for travelers from around the world.",
      "brochure-publish-anytime": "Publish Anytime",
      "brochure-publish-anytime-text": "Create tours and add stops whenever you want. Update content as your city changes.",
      "brochure-earn-money": "Earn Money",
      "brochure-earn-money-text": "Earn royalties when listeners spend time with your tours.",
      "brochure-meet-people": "Meet People",
      "brochure-meet-people-text": "Connect with travelers from around the world and share your passion for your city.",
      "brochure-how-it-works": "How It Works",
      "brochure-step-profile": "Create Your Profile",
      "brochure-step-profile-text": "Sign up and tell visitors about yourself, your background, and what makes you unique.",
      "brochure-step-tours": "Design Your Tours",
      "brochure-step-tours-text": "Create tours that showcase what you love about your city. Add photos, descriptions, and audio stops.",
      "brochure-step-grow": "Publish & Grow",
      "brochure-step-grow-text": "Publish your tour and keep improving it over time as listeners explore your city.",
      "brochure-ready": "Ready to Get Started?",
      "brochure-or": "or",
      "brochure-go-dashboard": "Go to Dashboard",
      "brochure-create-account": "Create an account to start your journey as a guide.",
      "brochure-sign-up-now": "Sign Up Now",
      "brochure-promise": "Our Promise",
      "brochure-no-hidden-fees": "No Hidden Fees",
      "brochure-no-hidden-fees-text": "Simple subscription access for listeners and transparent royalty payouts for guides.",
      "brochure-control": "You're In Control",
      "brochure-control-text": "Publish tours, update content anytime, and build your audience.",
      "brochure-easy-tools": "Easy Tools",
      "brochure-easy-tools-text": "Simple tools to publish tours, manage stops, and grow your audience.",
      "brochure-global-reach": "Global Reach",
      "brochure-global-reach-text": "Connect with travelers searching for authentic local experiences.",

      "about-intro": "Hi! My name is Vallard and I live in the Portland, Oregon area. I'm happily married and have 4 amazing kids.",
      "about-trip": "I took my first solo trip when I was 18 to Israel and lived on a kibbutz for several months. It was the first time I ventured out. Like you, I love to travel. I've realized the part I love the most about it is making connections with other people. I want to make a platform to enhance the experience of travelers and the people who live in the places they visit.",
      "about-connect-heading": "Connect globally by connecting locally.",
      "about-social-issues": "There are two social issues I hope to solve with this platform.",
      "about-loneliness-title": "Loneliness",
      "about-loneliness-text": "The World Health Organization (WHO) stated that one in four people experience social isolation, and one in six adolescents is socially isolated and lonely, though this is likely an underestimation. Our research has uncovered a growing trend of solo travelers lately with the majority of this trend being females. We believe that connections with others is the key to happiness and we want to help people make those connections. The WHO also stated that social connection has profound benefits for improving health, education, and the economy.",
      "about-source": "Source",
      "about-good-life": "I recently read The Good Life by Robert Waldinger and Marc Schulz. In this book they talk about the Harvard Study of Adult Development, the longest running study of adult life that's ever been done. They found that the happiest and healthiest people had the strongest relationships. This site is to help make more connections.",
      "about-empower-title": "Empower emerging entrepreneurs",
      "about-empower-text": "We have seen how large corporations like Airbnb or Uber have taken advantage of people all over the world by taking a large percentage of their earnings. Those companies require an initial outlay of capital that is becoming harder for most people to obtain. Houses and cars cost a considerable amount of money. With a tour-based business, there are very few barriers to entry. Anybody with grit and hustle can have the flexibility to run their own business. In this way I want to bring economic freedom to people all over the world. I also think that a local can give a better experience than a large corporation.",
      "about-travel-peace": "As a lifelong traveler and a person who has lived in many different places, I have made real lasting connections with people from all over the world even if our contact was brief. Travel helps eliminate fear, prejudice, and hate. It is the best education a person can have to stop wars and bring more peace to the world.",
      "about-money-heading": "How Torgyd makes money",
      "about-money-text": "This project is evolving into a subscription-based audio tour experience. The goal is to make it easy to discover and listen to location-based tours, while ensuring guides get paid fairly.",
      "about-listeners": "Listeners subscribe monthly for unlimited access to audio tours.",
      "about-guides": "Guides earn royalties based on listen time (Spotify-style payouts).",
      "about-eatwith": "Eat with the Natives is a free experimental service I think is cool that I wanted to try out.",
      "about-subscription": "In the subscription model, the platform stays simple: users pay a subscription, guides get paid based on listening, and there's no per-tour pricing.",

      "safety-title": "Safety at Torgyd: Our Top Priority",
      "safety-intro": "At Torgyd, we are committed to creating a safe and trustworthy environment for tourists and locals alike to connect and share unique experiences. Your safety is our highest priority, and we encourage all users to prioritize it as well in every interaction.",
      "safety-confidence-heading": "Connect with Confidence",
      "safety-social-title": "Social Media Profiles:",
      "safety-social-text": "All connections on our platform are initiated through social media, providing a layer of transparency. We encourage users to review social media profiles thoroughly before agreeing to meet. This step is crucial in establishing trust and ensuring mutual comfort.",
      "safety-communication-title": "Transparent Communication:",
      "safety-communication-text": "Clear and open communication is key. Discuss your plans in detail, share expectations, and do not hesitate to ask questions. Always inform someone you trust about your plans and where you will be.",
      "safety-meeting-heading": "Meeting Safely",
      "safety-public-title": "Choose Public Venues:",
      "safety-public-text": "For all meetups, whether it's for coffee, a meal, or a drink, always choose public and well-populated places. Restaurants, cafes, and bars in central locations are ideal. These settings not only ensure safety but also contribute to a relaxed and enjoyable experience.",
      "safety-locale-title": "Be Informed About the Locale:",
      "safety-locale-text": "Familiarize yourself with the meeting location beforehand. Know the area's general safety, cultural norms, and public transport options. If you're a tourist, take the time to research the area; if you're a local, choose a location you're comfortable with and share any relevant information with your guest.",
      "safety-sober-title": "Stay Sober and Alert:",
      "safety-sober-text": "While enjoying your time, it's important to stay alert and maintain control of your situation. Limit alcohol consumption and avoid substances that could impair your judgment.",
      "safety-emergency-heading": "In Case of Emergency",
      "safety-emergency-title": "Emergency Contacts:",
      "safety-emergency-text": "Always have a list of emergency contacts, including local authorities and your embassy if you're a tourist. Do not rely solely on your host or guest for this information.",
      "safety-instincts-title": "Trust Your Instincts:",
      "safety-instincts-text": "If at any point you feel uncomfortable or unsafe, trust your instincts and do not hesitate to end the meeting politely but firmly. Your safety is more important than social niceties.",
      "safety-after-heading": "After Your Meeting",
      "safety-feedback-title": "Leave Feedback and Reviews:",
      "safety-feedback-text": "After your meeting, we encourage you to leave feedback. Your reviews help us maintain a safe community and assist others in making informed decisions.",
      "safety-closing": "Safety is a shared responsibility, and by following these guidelines, we believe you can have enjoyable and memorable experiences through Torgyd. Should you have any concerns or need assistance, our support team is always here to help.",

      "privacy-title": "Privacy",
      "privacy-text": "The data you give me I do not share.\nI do not take it anywhere.\nI do not sell it in a box.\nI do not sell it to a fox.\nI do not track the clicks you make.\nI do not track the moves you take.\nFacebook, Google and all their trackers\nThey can all go suck on crackers.\nI do not track you here or there.\nI do not track you anywhere.",

      "admin-summary": "Users: {{users}} · Guides: {{guides}} · Tours: {{tours}}",
      "refresh": "Refresh",
      "admin-signin-required": "Please sign in to access admin tools.",
      "admin-access-denied": "Access denied. This page is for admins only.",
      "error": "Error",
      "admin-all-users": "All Users",
      "admin-search-users": "Search by email or id...",
      "admin-email": "Email",
      "admin-signed-up": "Signed up",
      "admin-superuser": "Superuser",
      "admin-active": "Active",
      "admin-verified": "Verified",
      "yes": "Yes",
      "no": "No",
      "admin-no-users": "No users found.",
      "admin-all-guides": "All Guides",
      "admin-search-guides": "Search by name, email, user id, or id...",
      "admin-guide": "Guide",
      "admin-created": "Created",
      "admin-user": "user",
      "admin-no-guides": "No guides found.",
      "admin-all-tours": "All Tours",
      "admin-search-tours": "Search by title or id...",
      "admin-title": "Title",
      "admin-view": "View",
      "admin-open": "Open",
      "admin-no-tours": "No tours found.",

      "footer-about": "About",
      "footer-links": "Links",
      "footer-safety": "Safety",
      "footer-privacy": "Privacy",
      "footer-socials": "Connect",
      "footer-tagline": "Authentic local experiences, one tour at a time.",
      "footer-rights": "All rights reserved."
    }
  },
  it: {
    translation: {
      "signup": "Registrati",
      "signin": "Accedi",
      "signin-already-have-account": "Hai già un account?",
      "signin-with-google": "Accedi con Google",
      "signin-no-account": "Nessun account?",
      "signin-forgot-password": "Password dimenticata?",
      "update-profile": "Aggiorna profilo",
      "become-tourguide": "Diventa una Guida",
      "search-go": "Vai!",
      "search-random": "Casuale",
      "search-placeholder": "Cerca destinazioni",

      "home": "Home",
      "dashboard": "Dashboard",
      "admin": "Admin",
      "logout": "Esci",
      "loading": "Caricamento...",
      "cancel": "Annulla",
      "delete": "Elimina",
      "edit": "Modifica",
      "close": "Chiudi",
      "create": "Crea",
      "search": "Cerca",
      "play": "Riproduci",
      "pause": "Pausa",
      "previous": "Precedente",
      "next": "Successivo",
      "duration": "durata",
      "text": "Testo",
      "by": "Di {{name}}",
      "hours-label": "ore",
      "valid-url-error": "Inserisci un URL valido",
      "valid-email-error": "Inserisci un indirizzo email valido",
      "email-not-valid": "L'email non è valida",
      "phone-valid-error": "Inserisci un numero di telefono valido.",
      "password-empty-error": "La password non può essere vuota.",
      "phone-number": "Numero di telefono",
      "email": "email",
      "password": "password",
      "enter-phone-number": "inserisci numero di telefono",
      "enter-email": "inserisci email",
      "enter-password": "inserisci password",
      "enter-email-placeholder": "Inserisci email",
      "forgot-password": "Password dimenticata",
      "reset-password": "Reimposta password",
      "reset-password-for": "Inserisci la nuova password per",
      "enter-new-password": "Inserisci nuova password",
      "enter-new-password-aria": "inserisci nuova password",
      "images": "Immagini",
      "upload-images-help": "Carica immagini (max 5MB)",
      "image-type-error": "Seleziona un file immagine (jpeg, png o gif)",
      "image-size-error": "Seleziona un file più piccolo (meno di 5MB)",
      "preview": "anteprima",
      "notfound-message": "La pagina che stai cercando non esiste. Forse vuoi provare questo pulsante?",
      "click-me": "Cliccami",
      "clicked-times": "Hai cliccato {{count}} volte",
      "or-go-home": "Oppure puoi sempre tornare a",
      "error-user-exists": "Spiacente, questo utente esiste già. Usa un indirizzo email diverso oppure",
      "error-sign-in-link": "accedi!",
      "error-reset-bad-token": "Spiacente, questo token per reimpostare la password non è valido. Prova a reimpostare di nuovo la password.",
      "error-login-bad-credentials": "Spiacente, email o password non sono corrette. Riprova.",
      "error-reset-password-link-prefix": "Se hai dimenticato la password, puoi",
      "error-reset-password-link": "reimpostarla qui.",
      "message-password-reset": "Se hai inserito un'email valida, le istruzioni per reimpostare la password sono state inviate alla tua email. Controlla la posta e segui le istruzioni.",
      "message-password-reset-success": "La password è stata reimpostata. Accedi con la tua nuova password.",
      "signing-in-google": "Accesso con Google...",
      "toggle-navigation": "Apri navigazione",
      "select-language": "Seleziona lingua",
      "user-menu": "Menu utente",

      "home-hero-title": "La tua avventura locale ti aspetta",
      "home-hero-subtitle": "Scopri tour audio basati sulla posizione creati da guide indipendenti",
      "home-signup-ad": "Unisciti come guida, pubblica tour audio con tappe sulla mappa e guadagna royalties mentre gli ascoltatori esplorano.",

      "search-where": "Dove",
      "search-destinations": "Cerca destinazioni",
      "search-city-placeholder": "Cerca una città...",

      "stops-count": "{{count}} tappe",
      "stops-count_one": "{{count}} tappa",
      "stops-count_other": "{{count}} tappe",
      "tours-count_one": "{{count}} tour",
      "tours-count_other": "{{count}} tour",
      "stops-label": "tappe",
      "tours-label": "tour",
      "radius-label": "raggio",
      "text-tour": "Tour testuale",
      "text-stop": "Tappa testuale",
      "no-audio-yet": "Nessun audio ancora",
      "unknown-stop": "Tappa sconosciuta",
      "unknown-tour": "Tour sconosciuto",
      "stop-x-of-y": "Tappa {{current}} di {{total}}",

      "location-experiences-guided-tours": "Tour Disponibili",
      "location-no-experiences": "Nessun tour disponibile in questa posizione. Torna presto!",
      "location-no-information": "Posizione non trovata. Prova un'altra destinazione.",
      "location-experiences-in": "Esperienze a {{location}}",
      "location-tours-available": "{{count}} tour disponibili",
      "location-tours-available_one": "{{count}} tour disponibile",
      "location-tours-available_other": "{{count}} tour disponibili",
      "location-audio-tours-note": "Tour audio basati sulla posizione (senza date o dimensioni del gruppo).",
      "location-no-tours-found": "Nessun tour trovato",
      "location-empty-description": "Non ci sono ancora tour disponibili in questa posizione. Torna presto!",
      "location-become-guide-here": "Diventa una guida qui",

      "map-explore-nearby": "Esplora nei dintorni",
      "map-audio-tours-around-you": "Tour audio intorno a te",
      "map-no-audio-tours": "Ancora nessun tour audio qui",
      "map-empty-description": "Cerca un'altra città o crea il primo tour per questa zona.",
      "map-start-tour": "Inizia un tour",
      "map-view-on-map": "Vedi sulla mappa",
      "map-view-on-map-arrow": "Vedi sulla mappa ->",
      "map-zoom-in": "Ingrandisci",
      "map-zoom-out": "Riduci",
      "map-drag-to-reposition": "{{title}} (trascina per riposizionare)",
      "map-km-away": "{{distance}}km di distanza",
      "map-stop-number": "Tappa {{number}}",
      "map-thumbs-up": "Mi piace",
      "map-signin-rate": "Accedi per valutare",
      "map-view-tour": "Vedi tour",
      "map-loading-tracks": "Caricamento tracce...",
      "map-pin-save-error": "Impossibile salvare la posizione del pin. Riprova.",

      "audio-previous-stop": "Tappa precedente",
      "audio-next-stop": "Tappa successiva",
      "audio-seek": "Cerca",

      "comments-title": "Commenti",
      "comments-load-error": "Impossibile caricare i commenti.",
      "comments-post-error": "Impossibile pubblicare il commento. Riprova.",
      "comments-just-now": "proprio ora",
      "comments-minutes-ago": "{{count}} min fa",
      "comments-hours-ago": "{{count}} h fa",
      "comments-days-ago": "{{count}} g fa",
      "comments-placeholder": "Condividi i tuoi pensieri su questa tappa...",
      "comments-posting": "Pubblicazione...",
      "comments-post": "Pubblica",
      "comments-signin": "Accedi per lasciare un commento",
      "comments-loading": "Caricamento commenti...",
      "comments-empty": "Ancora nessun commento.",
      "comments-be-first": " Sii il primo!",

      "tourguide-get-started": "Crea il Tuo Profilo Guida",
      "tourguide-get-started-paragraph": "Configura il tuo profilo per iniziare a pubblicare tour audio e connetterti con gli ascoltatori.",
      "tourguide-create-guide-profile": "Inizia",
      "tourguide-dashboard": "Dashboard",
      "tourguide-my-tours": "I Miei Tour",
      "tourguide-schedule": "Programma",
      "tourguide-profile": "Profilo",
      "tourguide-create-tour": "Crea Tour",
      "tourguide-no-tours": "Non hai ancora creato nessun tour. Inizia creando il tuo primo tour!",

      "guide-edit-profile": "Modifica profilo",
      "guide-create-first-tour": "Crea il tuo primo tour",
      "guide-edit-your-profile": "Modifica il tuo profilo",
      "guide-create-profile": "Crea il tuo profilo guida",
      "guide-update-info-subtitle": "Aggiorna le tue informazioni per attirare più visitatori",
      "guide-create-info-subtitle": "Configura il tuo profilo per iniziare a offrire tour",
      "guide-profile-photo": "Foto profilo",
      "guide-map-pin": "Pin sulla mappa",
      "guide-color": "Colore",
      "guide-emoji": "Emoji",
      "guide-pin-color-aria": "Colore pin {{color}}",
      "guide-pin-emoji-aria": "Emoji pin {{emoji}}",
      "guide-name": "Nome guida",
      "guide-name-placeholder": "Il tuo nome o nome aziendale",
      "guide-name-help": "È così che i visitatori ti identificheranno",
      "guide-location": "Posizione",
      "guide-location-placeholder": "Seleziona la tua posizione",
      "guide-location-missing": "Non vedi la tua posizione?",
      "guide-contact-us": "Contattaci",
      "guide-languages-spoken": "Lingue parlate",
      "guide-bio": "Bio",
      "guide-bio-placeholder": "Racconta ai visitatori di te, della tua esperienza e di cosa rende speciali i tuoi tour...",
      "guide-contact-info": "Informazioni di contatto",
      "guide-contact-info-help": "Aggiungi almeno un modo per farti contattare dai visitatori. Queste informazioni saranno visibili sul tuo profilo pubblico.",
      "guide-website": "Sito web",
      "guide-save-profile": "Salva profilo",
      "guide-contact-via": "Contatta tramite:",
      "guide-name-required": "Inserisci il tuo nome o nome aziendale",
      "guide-bio-required": "Racconta ai visitatori di te e dei tuoi tour",
      "guide-location-required": "Seleziona la tua posizione",
      "guide-language-required": "Seleziona almeno una lingua",
      "guide-contact-required": "Aggiungi almeno un modo per farti contattare dai visitatori",

      "language-english": "Inglese",
      "language-spanish": "Spagnolo",
      "language-french": "Francese",
      "language-german": "Tedesco",
      "language-italian": "Italiano",
      "language-portuguese": "Portoghese",
      "language-chinese": "Cinese mandarino",
      "language-russian": "Russo",
      "language-korean": "Coreano",
      "language-japanese": "Giapponese",
      "language-arabic": "Arabo",
      "language-hebrew": "Ebraico",

      "category-general": "Generale",
      "category-ghost-tour": "Tour dei fantasmi",
      "category-historical": "Storico",
      "category-pop-culture": "Cultura pop",
      "category-family-history": "Storia familiare",
      "category-food-drink": "Cibo e bevande",
      "category-architecture": "Architettura",
      "category-nature-parks": "Natura e parchi",
      "category-art-culture": "Arte e cultura",

      "tour-title": "Titolo del Tour",
      "tour-description": "Descrizione",
      "tour-duration": "Durata (ore)",
      "tour-cost": "Prezzo",
      "tour-cost-type": "Tipo di Prezzo",
      "tour-max-size": "Dimensione Massima Gruppo",
      "tour-per-person": "Per Persona",
      "tour-per-tour": "Per Tour",
      "tour-create": "Crea Tour",
      "tour-update": "Salva Modifiche",
      "tour-delete": "Elimina Tour",
      "tour-schedule": "Programma Date",
      "tour-edit": "Modifica Tour",
      "tour-create-new": "Crea nuovo tour",
      "tour-editor-subtitle-edit": "Compila i dettagli qui sotto per aggiornare il tuo tour",
      "tour-editor-subtitle-create": "Compila i dettagli qui sotto per creare un nuovo tour",
      "tour-images": "Immagini del tour",
      "tour-title-placeholder": "es. Tour audio dei luoghi nascosti",
      "tour-description-placeholder": "Descrivi l'esperienza del tour, cosa vedranno e faranno i visitatori...",
      "tour-category": "Categoria",
      "tour-privacy-level": "Livello di privacy",
      "tour-public": "Pubblico",
      "tour-private": "Privato",
      "tour-unlisted": "Non in elenco",
      "tour-public-description": "Visibile a tutti sulla mappa",
      "tour-private-description": "Visibile solo alle persone con cui lo condividi",
      "tour-unlisted-description": "Nascosto dalla mappa, accessibile tramite link",
      "tour-manage-sharing": "Gestisci condivisione",
      "tour-delete-confirm-title": "Eliminare il tour?",
      "tour-delete-confirm-message": "Questa azione non può essere annullata. Sei sicuro di voler eliminare questo tour?",
      "tour-title-required": "Il titolo è obbligatorio",
      "tour-description-required": "La descrizione è obbligatoria",
      "tour-about-this-tour": "Informazioni su questo tour",
      "tour-stops": "Tappe",
      "tour-play-from-start": "Riproduci dall'inizio",
      "tour-sign-in-to-listen": "Accedi per ascoltare",
      "tour-loading-stops": "Caricamento tappe...",
      "tour-no-stops-yet": "Ancora nessuna tappa.",
      "tour-guide": "Guida",
      "tour-start-listening": "Inizia ad ascoltare",
      "tour-stops-ready-on-map": "{{count}} tappe pronte sulla mappa",
      "tour-stops-ready-on-map_one": "{{count}} tappa pronta sulla mappa",
      "tour-stops-ready-on-map_other": "{{count}} tappe pronte sulla mappa",
      "tour-open-first-stop-map": "Apri la prima tappa sulla mappa",

      "track-tour-stops": "Tappe del tour",
      "track-add-stop": "Aggiungi tappa",
      "track-edit-stop": "Modifica tappa",
      "track-view-on-map": "Vedi sulla mappa",
      "track-empty": "Ancora nessuna tappa. Clicca sulla mappa per posizionare un pin e aggiungere la prima tappa!",
      "track-delete-title": "Eliminare la tappa?",
      "track-delete-message": "Questa tappa del tour verrà eliminata definitivamente. L'azione non può essere annullata.",
      "track-delete-stop": "Elimina tappa",
      "track-audio-file": "File audio",
      "track-audio-file-optional": "File audio (opzionale)",
      "track-stop-title": "Titolo tappa *",
      "track-stop-title-placeholder": "es. Benvenuto",
      "track-description": "Descrizione",
      "track-description-placeholder": "Descrivi cosa ascolteranno i visitatori in questa posizione...",
      "track-text-content": "Contenuto testuale",
      "track-text-content-placeholder": "Script opzionale o contenuto solo testuale...",
      "track-stop-location": "Posizione tappa *",
      "track-location-help": "Clicca sulla mappa per posizionare un pin per questa tappa. Puoi anche trascinare il pin per regolare la posizione.",
      "track-latitude": "Latitudine *",
      "track-longitude": "Longitudine *",
      "track-sequence-order": "Ordine sequenza",
      "track-sequence-help-zero": "Ordine in cui questa tappa appare nel tour (0 = prima)",
      "track-sequence-help-one": "Ordine di questa tappa nel tour (1 = prima)",
      "track-uploading": "Caricamento...",
      "track-saving": "Salvataggio...",
      "track-update-stop": "Aggiorna tappa",
      "track-duration": "Durata:",
      "track-additional-notes": "Note aggiuntive",
      "track-additional-notes-placeholder": "Eventuali note aggiuntive (opzionale)",
      "track-provide-content-help": "Fornisci contenuto testuale o audio (o entrambi)",
      "track-tour": "Tour *",
      "track-select-tour-placeholder": "Seleziona un tour...",
      "track-create-new-tour": "+ Crea nuovo tour",
      "track-new-tour-title": "Titolo nuovo tour *",
      "track-new-tour-description": "Descrizione nuovo tour",
      "track-tour-title-placeholder": "Titolo del tour",
      "track-new-tour-description-placeholder": "Descrizione del tour (opzionale)",
      "track-create-tour": "Crea tour",
      "track-location": "Posizione",
      "track-title": "Titolo *",
      "track-title-placeholder": "Titolo tappa",
      "track-text-content-full-placeholder": "Scrivi cosa vuoi dire in questa tappa...",
      "track-error-select-audio": "Seleziona un file audio (MP3, M4A, WAV, ecc.)",
      "track-error-audio-duration": "Impossibile leggere la durata del file audio",
      "track-error-title-required": "Il titolo è obbligatorio",
      "track-error-valid-latitude": "Latitudine valida obbligatoria (-90 a 90)",
      "track-error-valid-longitude": "Longitudine valida obbligatoria (-180 a 180)",
      "track-error-audio-or-text": "Aggiungi un file audio o contenuto testuale",
      "track-error-text-or-audio": "Aggiungi contenuto testuale o un file audio",
      "track-error-sequence": "La sequenza deve essere 0 o superiore",
      "track-error-get-upload-url": "Impossibile ottenere l'URL di caricamento",
      "track-error-upload-audio": "Impossibile caricare il file audio",
      "track-error-create-stop": "Impossibile creare la tappa",
      "track-error-update-stop": "Impossibile aggiornare la tappa",
      "track-error-save-stop": "Impossibile salvare la tappa",
      "track-error-read-audio-file": "Impossibile leggere il file audio. Prova un file diverso.",
      "track-error-enter-tour-title": "Inserisci un titolo per il tour",
      "track-error-create-tour": "Impossibile creare il tour",
      "track-error-select-tour": "Seleziona un tour o creane uno nuovo",
      "track-error-title": "Inserisci un titolo",
      "track-error-content": "Fornisci audio o contenuto testuale",
      "track-error-duration": "Impossibile leggere la durata audio. Scegli un file audio diverso.",
      "track-error-upload-track": "Impossibile caricare la traccia. Riprova.",

      "sharing-title": "Gestisci condivisione tour",
      "sharing-info": "Condividi questo tour privato con utenti specifici inserendo il loro indirizzo email. Potranno vedere e ascoltare il tour dopo la condivisione.",
      "sharing-user-email": "Email utente",
      "sharing": "Condivisione...",
      "share": "Condividi",
      "sharing-shared-with": "Condiviso con ({{count}})",
      "sharing-empty": "Questo tour non è ancora stato condiviso con nessuno.",
      "sharing-date": "Condiviso {{date}}",
      "sharing-remove-access": "Rimuovi accesso",
      "sharing-remove": "Rimuovi",

      "schedule-title": "Programma Tour",
      "schedule-add-date": "Aggiungi Data",
      "schedule-date": "Data e Ora",
      "schedule-capacity": "Posti Disponibili",
      "schedule-no-dates": "Nessuna data programmata. Aggiungi la tua prima data disponibile!",
      "schedule-add-new-date": "Aggiungi nuova data",
      "schedule-date-only": "Data",
      "schedule-time": "Ora",
      "schedule-upcoming-dates": "Date future",
      "schedule-past-dates": "Date passate",
      "schedule-booked": "{{booked}} / {{capacity}} prenotati",
      "schedule-attended": "{{booked}} / {{capacity}} presenti",
      "schedule-delete-date": "Elimina questa data",
      "schedule-select-date-error": "Seleziona una data",
      "schedule-future-date-error": "Seleziona una data e ora future",
      "schedule-tour-fallback": "Tour",

      "brochure-share-world": "Condividi il tuo mondo",
      "brochure-subtitle": "Trasforma la tua conoscenza locale in esperienze indimenticabili per viaggiatori da tutto il mondo.",
      "brochure-publish-anytime": "Pubblica quando vuoi",
      "brochure-publish-anytime-text": "Crea tour e aggiungi tappe quando vuoi. Aggiorna i contenuti mentre la tua città cambia.",
      "brochure-earn-money": "Guadagna",
      "brochure-earn-money-text": "Guadagna royalties quando gli ascoltatori passano tempo sui tuoi tour.",
      "brochure-meet-people": "Incontra persone",
      "brochure-meet-people-text": "Connettiti con viaggiatori da tutto il mondo e condividi la tua passione per la tua città.",
      "brochure-how-it-works": "Come funziona",
      "brochure-step-profile": "Crea il tuo profilo",
      "brochure-step-profile-text": "Registrati e racconta ai visitatori chi sei, il tuo background e cosa ti rende unico.",
      "brochure-step-tours": "Progetta i tuoi tour",
      "brochure-step-tours-text": "Crea tour che mostrano ciò che ami della tua città. Aggiungi foto, descrizioni e tappe audio.",
      "brochure-step-grow": "Pubblica e cresci",
      "brochure-step-grow-text": "Pubblica il tuo tour e miglioralo nel tempo mentre gli ascoltatori esplorano la tua città.",
      "brochure-ready": "Pronto per iniziare?",
      "brochure-or": "oppure",
      "brochure-go-dashboard": "Vai alla dashboard",
      "brochure-create-account": "Crea un account per iniziare il tuo percorso come guida.",
      "brochure-sign-up-now": "Registrati ora",
      "brochure-promise": "La nostra promessa",
      "brochure-no-hidden-fees": "Nessun costo nascosto",
      "brochure-no-hidden-fees-text": "Accesso semplice in abbonamento per gli ascoltatori e pagamenti royalty trasparenti per le guide.",
      "brochure-control": "Hai il controllo",
      "brochure-control-text": "Pubblica tour, aggiorna i contenuti quando vuoi e costruisci il tuo pubblico.",
      "brochure-easy-tools": "Strumenti semplici",
      "brochure-easy-tools-text": "Strumenti semplici per pubblicare tour, gestire tappe e far crescere il tuo pubblico.",
      "brochure-global-reach": "Portata globale",
      "brochure-global-reach-text": "Connettiti con viaggiatori in cerca di esperienze locali autentiche.",

      "about-intro": "Ciao! Mi chiamo Vallard e vivo nella zona di Portland, Oregon. Sono felicemente sposato e ho 4 figli fantastici.",
      "about-trip": "Ho fatto il mio primo viaggio da solo a 18 anni, in Israele, e ho vissuto per diversi mesi in un kibbutz. È stata la prima volta che mi sono davvero avventurato fuori. Come te, amo viaggiare. Ho capito che la parte che amo di più del viaggio è creare connessioni con altre persone. Voglio costruire una piattaforma che migliori l'esperienza dei viaggiatori e delle persone che vivono nei luoghi che visitano.",
      "about-connect-heading": "Connettiti globalmente creando connessioni locali.",
      "about-social-issues": "Ci sono due problemi sociali che spero di aiutare a risolvere con questa piattaforma.",
      "about-loneliness-title": "Solitudine",
      "about-loneliness-text": "L'Organizzazione Mondiale della Sanità (OMS) ha affermato che una persona su quattro sperimenta isolamento sociale e un adolescente su sei è socialmente isolato e solo, anche se probabilmente è una sottostima. La nostra ricerca ha evidenziato una crescita dei viaggiatori solitari, soprattutto donne. Crediamo che le connessioni con gli altri siano fondamentali per la felicità e vogliamo aiutare le persone a crearle. L'OMS ha anche affermato che la connessione sociale porta profondi benefici per salute, istruzione ed economia.",
      "about-source": "Fonte",
      "about-good-life": "Di recente ho letto The Good Life di Robert Waldinger e Marc Schulz. Nel libro parlano dell'Harvard Study of Adult Development, lo studio sulla vita adulta più lungo mai realizzato. Hanno scoperto che le persone più felici e sane erano quelle con le relazioni più forti. Questo sito serve ad aiutare a creare più connessioni.",
      "about-empower-title": "Sostenere gli imprenditori emergenti",
      "about-empower-text": "Abbiamo visto grandi aziende come Airbnb o Uber approfittare di persone in tutto il mondo trattenendo una grande percentuale dei loro guadagni. Queste aziende richiedono un investimento iniziale che per molti è sempre più difficile ottenere. Case e auto costano molto. Con un'attività basata sui tour, le barriere d'ingresso sono molto basse. Chiunque abbia determinazione e voglia di fare può avere la flessibilità di gestire la propria attività. In questo modo voglio portare libertà economica a persone in tutto il mondo. Credo anche che una persona del posto possa offrire un'esperienza migliore di una grande azienda.",
      "about-travel-peace": "Da viaggiatore di lunga data e persona che ha vissuto in molti luoghi diversi, ho creato connessioni reali e durature con persone di tutto il mondo, anche quando il contatto è stato breve. Il viaggio aiuta a eliminare paura, pregiudizio e odio. È la migliore educazione che una persona possa avere per fermare le guerre e portare più pace nel mondo.",
      "about-money-heading": "Come guadagna Torgyd",
      "about-money-text": "Questo progetto sta diventando un'esperienza di tour audio basata su abbonamento. L'obiettivo è rendere facile scoprire e ascoltare tour basati sulla posizione, assicurando allo stesso tempo che le guide vengano pagate in modo equo.",
      "about-listeners": "Gli ascoltatori si abbonano mensilmente per avere accesso illimitato ai tour audio.",
      "about-guides": "Le guide guadagnano royalties in base al tempo di ascolto, con pagamenti in stile Spotify.",
      "about-eatwith": "Eat with the Natives è un servizio sperimentale gratuito che trovo interessante e volevo provare.",
      "about-subscription": "Nel modello in abbonamento, la piattaforma resta semplice: gli utenti pagano un abbonamento, le guide vengono pagate in base all'ascolto e non c'è un prezzo per singolo tour.",

      "safety-title": "Sicurezza su Torgyd: la nostra priorità",
      "safety-intro": "In Torgyd ci impegniamo a creare un ambiente sicuro e affidabile in cui turisti e persone del posto possano connettersi e condividere esperienze uniche. La tua sicurezza è la nostra priorità principale e incoraggiamo tutti gli utenti a metterla al primo posto in ogni interazione.",
      "safety-confidence-heading": "Connettiti con fiducia",
      "safety-social-title": "Profili social:",
      "safety-social-text": "Tutte le connessioni sulla nostra piattaforma iniziano tramite social media, offrendo un livello di trasparenza. Incoraggiamo gli utenti a esaminare attentamente i profili social prima di accettare un incontro. Questo passaggio è essenziale per creare fiducia e comfort reciproco.",
      "safety-communication-title": "Comunicazione trasparente:",
      "safety-communication-text": "Una comunicazione chiara e aperta è fondamentale. Discuti i tuoi piani in dettaglio, condividi le aspettative e non esitare a fare domande. Informa sempre una persona di fiducia sui tuoi piani e su dove sarai.",
      "safety-meeting-heading": "Incontrarsi in sicurezza",
      "safety-public-title": "Scegli luoghi pubblici:",
      "safety-public-text": "Per ogni incontro, che sia per un caffè, un pasto o un drink, scegli sempre luoghi pubblici e frequentati. Ristoranti, caffè e bar in zone centrali sono ideali. Questi contesti garantiscono sicurezza e contribuiscono a un'esperienza rilassata e piacevole.",
      "safety-locale-title": "Informati sul luogo:",
      "safety-locale-text": "Familiarizza in anticipo con il luogo dell'incontro. Informati sulla sicurezza generale della zona, sulle norme culturali e sui trasporti pubblici. Se sei turista, prenditi il tempo per fare ricerche; se sei del posto, scegli un luogo in cui ti senti a tuo agio e condividi le informazioni utili con il tuo ospite.",
      "safety-sober-title": "Resta sobrio e vigile:",
      "safety-sober-text": "Mentre ti godi il momento, è importante restare vigile e mantenere il controllo della situazione. Limita il consumo di alcol ed evita sostanze che possano compromettere il tuo giudizio.",
      "safety-emergency-heading": "In caso di emergenza",
      "safety-emergency-title": "Contatti di emergenza:",
      "safety-emergency-text": "Tieni sempre a portata di mano un elenco di contatti di emergenza, incluse autorità locali e ambasciata se sei turista. Non fare affidamento solo sul tuo host o ospite per queste informazioni.",
      "safety-instincts-title": "Fidati del tuo istinto:",
      "safety-instincts-text": "Se in qualsiasi momento ti senti a disagio o non al sicuro, fidati del tuo istinto e non esitare a terminare l'incontro con gentilezza ma fermezza. La tua sicurezza è più importante delle formalità sociali.",
      "safety-after-heading": "Dopo l'incontro",
      "safety-feedback-title": "Lascia feedback e recensioni:",
      "safety-feedback-text": "Dopo l'incontro ti incoraggiamo a lasciare un feedback. Le recensioni ci aiutano a mantenere una comunità sicura e aiutano gli altri a prendere decisioni informate.",
      "safety-closing": "La sicurezza è una responsabilità condivisa e, seguendo queste linee guida, crediamo che tu possa vivere esperienze piacevoli e memorabili con Torgyd. Se hai dubbi o hai bisogno di assistenza, il nostro team di supporto è sempre qui per aiutarti.",

      "privacy-title": "Privacy",
      "privacy-text": "I dati che mi dai non li condivido.\nNon li porto in giro.\nNon li vendo in una scatola.\nNon li vendo a nessuno.\nNon traccio i clic che fai.\nNon traccio i passi che fai.\nFacebook, Google e tutti i loro tracker\npossono restare fuori da qui.\nNon ti traccio qui o là.\nNon ti traccio da nessuna parte.",

      "admin-summary": "Utenti: {{users}} · Guide: {{guides}} · Tour: {{tours}}",
      "refresh": "Aggiorna",
      "admin-signin-required": "Accedi per usare gli strumenti admin.",
      "admin-access-denied": "Accesso negato. Questa pagina è riservata agli admin.",
      "error": "Errore",
      "admin-all-users": "Tutti gli utenti",
      "admin-search-users": "Cerca per email o id...",
      "admin-email": "Email",
      "admin-signed-up": "Registrato",
      "admin-superuser": "Superuser",
      "admin-active": "Attivo",
      "admin-verified": "Verificato",
      "yes": "Sì",
      "no": "No",
      "admin-no-users": "Nessun utente trovato.",
      "admin-all-guides": "Tutte le guide",
      "admin-search-guides": "Cerca per nome, email, id utente o id...",
      "admin-guide": "Guida",
      "admin-created": "Creato",
      "admin-user": "utente",
      "admin-no-guides": "Nessuna guida trovata.",
      "admin-all-tours": "Tutti i tour",
      "admin-search-tours": "Cerca per titolo o id...",
      "admin-title": "Titolo",
      "admin-view": "Vedi",
      "admin-open": "Apri",
      "admin-no-tours": "Nessun tour trovato.",

      "footer-about": "Chi Siamo",
      "footer-links": "Link",
      "footer-safety": "Sicurezza",
      "footer-privacy": "Privacy",
      "footer-socials": "Connettiti",
      "footer-tagline": "Esperienze locali autentiche, un tour alla volta.",
      "footer-rights": "Tutti i diritti riservati."
    }
  },
  es: {
    translation: {
      "signup": "Regístrate",
      "signin": "Iniciar sesión",
      "signin-already-have-account": "¿Ya tienes una cuenta?",
      "signin-with-google": "Iniciar sesión con Google",
      "signin-no-account": "¿No tienes una cuenta?",
      "signin-forgot-password": "¿Olvidaste tu contraseña?",
      "update-profile": "Actualizar perfil",
      "become-tourguide": "Sé un Guía",
      "search-go": "¡Ir!",
      "search-random": "Aleatorio",
      "search-placeholder": "Buscar destinos",

      "home": "Inicio",
      "dashboard": "Panel",
      "admin": "Admin",
      "logout": "Cerrar sesión",
      "loading": "Cargando...",
      "cancel": "Cancelar",
      "delete": "Eliminar",
      "edit": "Editar",
      "close": "Cerrar",
      "create": "Crear",
      "search": "Buscar",
      "play": "Reproducir",
      "pause": "Pausar",
      "previous": "Anterior",
      "next": "Siguiente",
      "duration": "duración",
      "text": "Texto",
      "by": "Por {{name}}",
      "hours-label": "horas",
      "valid-url-error": "Introduce una URL válida",
      "valid-email-error": "Introduce una dirección de correo válida",
      "email-not-valid": "El correo no es válido",
      "phone-valid-error": "Introduce un número de teléfono válido.",
      "password-empty-error": "La contraseña no puede estar vacía.",
      "phone-number": "Número de teléfono",
      "email": "correo",
      "password": "contraseña",
      "enter-phone-number": "introduce el número de teléfono",
      "enter-email": "introduce el correo",
      "enter-password": "introduce la contraseña",
      "enter-email-placeholder": "Introduce el correo",
      "forgot-password": "Olvidé mi contraseña",
      "reset-password": "Restablecer contraseña",
      "reset-password-for": "Introduce una nueva contraseña para",
      "enter-new-password": "Introduce la nueva contraseña",
      "enter-new-password-aria": "introduce la nueva contraseña",
      "images": "Imágenes",
      "upload-images-help": "Sube imágenes (máx. 5MB)",
      "image-type-error": "Selecciona un archivo de imagen (jpeg, png o gif)",
      "image-size-error": "Selecciona un archivo más pequeño (menos de 5MB)",
      "preview": "vista previa",
      "notfound-message": "La página que buscas no existe. Tal vez quieras probar este botón.",
      "click-me": "Haz clic",
      "clicked-times": "Has hecho clic {{count}} veces",
      "or-go-home": "O siempre puedes volver a",
      "error-user-exists": "Lo sentimos, este usuario ya existe. Usa otra dirección de correo o",
      "error-sign-in-link": "inicia sesión.",
      "error-reset-bad-token": "Lo sentimos, este token para restablecer la contraseña no es válido. Intenta restablecer tu contraseña de nuevo.",
      "error-login-bad-credentials": "Lo sentimos, tu correo o contraseña no son correctos. Inténtalo de nuevo.",
      "error-reset-password-link-prefix": "Si olvidaste tu contraseña, puedes",
      "error-reset-password-link": "restablecerla aquí.",
      "message-password-reset": "Si introdujiste un correo válido, se han enviado instrucciones para restablecer la contraseña. Revisa tu correo y sigue las instrucciones.",
      "message-password-reset-success": "Tu contraseña se ha restablecido. Inicia sesión con tu nueva contraseña.",
      "signing-in-google": "Iniciando sesión con Google...",
      "toggle-navigation": "Abrir navegación",
      "select-language": "Seleccionar idioma",
      "user-menu": "Menú de usuario",

      "home-hero-title": "Tu aventura local te espera",
      "home-hero-subtitle": "Descubre tours de audio basados en la ubicación creados por guías independientes",
      "home-signup-ad": "Únete como guía, publica tours con paradas en el mapa y gana regalías mientras los oyentes exploran.",

      "search-where": "Dónde",
      "search-destinations": "Buscar destinos",
      "search-city-placeholder": "Buscar una ciudad...",

      "stops-count": "{{count}} paradas",
      "stops-count_one": "{{count}} parada",
      "stops-count_other": "{{count}} paradas",
      "tours-count_one": "{{count}} tour",
      "tours-count_other": "{{count}} tours",
      "stops-label": "paradas",
      "tours-label": "tours",
      "radius-label": "radio",
      "text-tour": "Tour de texto",
      "text-stop": "Parada de texto",
      "no-audio-yet": "Sin audio todavía",
      "unknown-stop": "Parada desconocida",
      "unknown-tour": "Tour desconocido",
      "stop-x-of-y": "Parada {{current}} de {{total}}",

      "location-experiences-guided-tours": "Tours Disponibles",
      "location-no-experiences": "No hay tours disponibles en esta ubicación todavía. ¡Vuelve pronto!",
      "location-no-information": "Ubicación no encontrada. Por favor, intenta otro destino.",
      "location-experiences-in": "Experiencias en {{location}}",
      "location-tours-available": "{{count}} tours disponibles",
      "location-tours-available_one": "{{count}} tour disponible",
      "location-tours-available_other": "{{count}} tours disponibles",
      "location-audio-tours-note": "Tours de audio basados en la ubicación (sin fechas ni tamaños de grupo).",
      "location-no-tours-found": "No se encontraron tours",
      "location-empty-description": "Todavía no hay tours disponibles en esta ubicación. ¡Vuelve pronto!",
      "location-become-guide-here": "Sé guía aquí",

      "map-explore-nearby": "Explora cerca",
      "map-audio-tours-around-you": "Tours de audio cerca de ti",
      "map-no-audio-tours": "Aún no hay tours de audio aquí",
      "map-empty-description": "Busca otra ciudad o crea el primer tour para esta zona.",
      "map-start-tour": "Iniciar un tour",
      "map-view-on-map": "Ver en el mapa",
      "map-view-on-map-arrow": "Ver en el mapa ->",
      "map-zoom-in": "Acercar",
      "map-zoom-out": "Alejar",
      "map-drag-to-reposition": "{{title}} (arrastra para reposicionar)",
      "map-km-away": "a {{distance}}km",
      "map-stop-number": "Parada {{number}}",
      "map-thumbs-up": "Me gusta",
      "map-signin-rate": "Inicia sesión para calificar",
      "map-view-tour": "Ver tour",
      "map-loading-tracks": "Cargando pistas...",
      "map-pin-save-error": "No se pudo guardar la ubicación del pin. Inténtalo de nuevo.",

      "audio-previous-stop": "Parada anterior",
      "audio-next-stop": "Siguiente parada",
      "audio-seek": "Buscar",

      "comments-title": "Comentarios",
      "comments-load-error": "No se pudieron cargar los comentarios.",
      "comments-post-error": "No se pudo publicar el comentario. Inténtalo de nuevo.",
      "comments-just-now": "ahora mismo",
      "comments-minutes-ago": "hace {{count}} min",
      "comments-hours-ago": "hace {{count}} h",
      "comments-days-ago": "hace {{count}} d",
      "comments-placeholder": "Comparte tus pensamientos sobre esta parada...",
      "comments-posting": "Publicando...",
      "comments-post": "Publicar",
      "comments-signin": "Inicia sesión para dejar un comentario",
      "comments-loading": "Cargando comentarios...",
      "comments-empty": "Aún no hay comentarios.",
      "comments-be-first": " ¡Sé el primero!",

      "tourguide-get-started": "Crea Tu Perfil de Guía",
      "tourguide-get-started-paragraph": "Configura tu perfil para empezar a publicar tours de audio y conectar con oyentes.",
      "tourguide-create-guide-profile": "Comenzar",
      "tourguide-dashboard": "Panel",
      "tourguide-my-tours": "Mis Tours",
      "tourguide-schedule": "Horario",
      "tourguide-profile": "Perfil",
      "tourguide-create-tour": "Crear Tour",
      "tourguide-no-tours": "Aún no has creado ningún tour. ¡Empieza creando tu primer tour!",

      "guide-edit-profile": "Editar perfil",
      "guide-create-first-tour": "Crea tu primer tour",
      "guide-edit-your-profile": "Edita tu perfil",
      "guide-create-profile": "Crea tu perfil de guía",
      "guide-update-info-subtitle": "Actualiza tu información para atraer a más visitantes",
      "guide-create-info-subtitle": "Configura tu perfil para empezar a ofrecer tours",
      "guide-profile-photo": "Foto de perfil",
      "guide-map-pin": "Pin del mapa",
      "guide-color": "Color",
      "guide-emoji": "Emoji",
      "guide-pin-color-aria": "Color del pin {{color}}",
      "guide-pin-emoji-aria": "Emoji del pin {{emoji}}",
      "guide-name": "Nombre de guía",
      "guide-name-placeholder": "Tu nombre o nombre de empresa",
      "guide-name-help": "Así te identificarán los visitantes",
      "guide-location": "Ubicación",
      "guide-location-placeholder": "Selecciona tu ubicación",
      "guide-location-missing": "¿No ves tu ubicación?",
      "guide-contact-us": "Contáctanos",
      "guide-languages-spoken": "Idiomas hablados",
      "guide-bio": "Biografía",
      "guide-bio-placeholder": "Cuéntales a los visitantes sobre ti, tu experiencia y qué hace especiales tus tours...",
      "guide-contact-info": "Información de contacto",
      "guide-contact-info-help": "Añade al menos una forma para que los visitantes te contacten. Esta información será visible en tu perfil público.",
      "guide-website": "Sitio web",
      "guide-save-profile": "Guardar perfil",
      "guide-contact-via": "Contacto por:",
      "guide-name-required": "Introduce tu nombre o nombre de empresa",
      "guide-bio-required": "Cuéntales a los visitantes sobre ti y tus tours",
      "guide-location-required": "Selecciona tu ubicación",
      "guide-language-required": "Selecciona al menos un idioma",
      "guide-contact-required": "Añade al menos una forma para que los visitantes te contacten",

      "language-english": "Inglés",
      "language-spanish": "Español",
      "language-french": "Francés",
      "language-german": "Alemán",
      "language-italian": "Italiano",
      "language-portuguese": "Portugués",
      "language-chinese": "Chino mandarín",
      "language-russian": "Ruso",
      "language-korean": "Coreano",
      "language-japanese": "Japonés",
      "language-arabic": "Árabe",
      "language-hebrew": "Hebreo",

      "category-general": "General",
      "category-ghost-tour": "Tour de fantasmas",
      "category-historical": "Histórico",
      "category-pop-culture": "Cultura pop",
      "category-family-history": "Historia familiar",
      "category-food-drink": "Comida y bebida",
      "category-architecture": "Arquitectura",
      "category-nature-parks": "Naturaleza y parques",
      "category-art-culture": "Arte y cultura",

      "tour-title": "Título del Tour",
      "tour-description": "Descripción",
      "tour-duration": "Duración (horas)",
      "tour-cost": "Precio",
      "tour-cost-type": "Tipo de Precio",
      "tour-max-size": "Tamaño Máximo del Grupo",
      "tour-per-person": "Por Persona",
      "tour-per-tour": "Por Tour",
      "tour-create": "Crear Tour",
      "tour-update": "Guardar Cambios",
      "tour-delete": "Eliminar Tour",
      "tour-schedule": "Programar Fechas",
      "tour-edit": "Editar Tour",
      "tour-create-new": "Crear nuevo tour",
      "tour-editor-subtitle-edit": "Completa los detalles a continuación para actualizar tu tour",
      "tour-editor-subtitle-create": "Completa los detalles a continuación para crear un nuevo tour",
      "tour-images": "Imágenes del tour",
      "tour-title-placeholder": "p. ej., Tour de audio de joyas escondidas",
      "tour-description-placeholder": "Describe la experiencia del tour, lo que los visitantes verán y harán...",
      "tour-category": "Categoría",
      "tour-privacy-level": "Nivel de privacidad",
      "tour-public": "Público",
      "tour-private": "Privado",
      "tour-unlisted": "No listado",
      "tour-public-description": "Visible para todos en el mapa",
      "tour-private-description": "Solo visible para las personas con quienes lo compartes",
      "tour-unlisted-description": "Oculto del mapa, accesible mediante enlace",
      "tour-manage-sharing": "Gestionar uso compartido",
      "tour-delete-confirm-title": "¿Eliminar tour?",
      "tour-delete-confirm-message": "Esta acción no se puede deshacer. ¿Seguro que quieres eliminar este tour?",
      "tour-title-required": "El título es obligatorio",
      "tour-description-required": "La descripción es obligatoria",
      "tour-about-this-tour": "Acerca de este tour",
      "tour-stops": "Paradas",
      "tour-play-from-start": "Reproducir desde el inicio",
      "tour-sign-in-to-listen": "Inicia sesión para escuchar",
      "tour-loading-stops": "Cargando paradas...",
      "tour-no-stops-yet": "Aún no hay paradas.",
      "tour-guide": "Guía",
      "tour-start-listening": "Empieza a escuchar",
      "tour-stops-ready-on-map": "{{count}} paradas listas en el mapa",
      "tour-stops-ready-on-map_one": "{{count}} parada lista en el mapa",
      "tour-stops-ready-on-map_other": "{{count}} paradas listas en el mapa",
      "tour-open-first-stop-map": "Abrir la primera parada en el mapa",

      "track-tour-stops": "Paradas del tour",
      "track-add-stop": "Añadir parada",
      "track-edit-stop": "Editar parada",
      "track-view-on-map": "Ver en el mapa",
      "track-empty": "Aún no hay paradas. Haz clic en el mapa para colocar un pin y añadir tu primera parada.",
      "track-delete-title": "¿Eliminar parada?",
      "track-delete-message": "Esto eliminará permanentemente esta parada del tour. Esta acción no se puede deshacer.",
      "track-delete-stop": "Eliminar parada",
      "track-audio-file": "Archivo de audio",
      "track-audio-file-optional": "Archivo de audio (opcional)",
      "track-stop-title": "Título de la parada *",
      "track-stop-title-placeholder": "p. ej., Bienvenida",
      "track-description": "Descripción",
      "track-description-placeholder": "Describe lo que los visitantes escucharán en esta ubicación...",
      "track-text-content": "Contenido de texto",
      "track-text-content-placeholder": "Guion opcional o contenido solo de texto...",
      "track-stop-location": "Ubicación de la parada *",
      "track-location-help": "Haz clic en el mapa para colocar un pin para esta parada. También puedes arrastrar el pin para ajustar la ubicación.",
      "track-latitude": "Latitud *",
      "track-longitude": "Longitud *",
      "track-sequence-order": "Orden de secuencia",
      "track-sequence-help-zero": "Orden en que esta parada aparece en el tour (0 = primera)",
      "track-sequence-help-one": "Orden de esta parada en el tour (1 = primera)",
      "track-uploading": "Subiendo...",
      "track-saving": "Guardando...",
      "track-update-stop": "Actualizar parada",
      "track-duration": "Duración:",
      "track-additional-notes": "Notas adicionales",
      "track-additional-notes-placeholder": "Cualquier nota adicional (opcional)",
      "track-provide-content-help": "Proporciona contenido de texto o audio (o ambos)",
      "track-tour": "Tour *",
      "track-select-tour-placeholder": "Selecciona un tour...",
      "track-create-new-tour": "+ Crear nuevo tour",
      "track-new-tour-title": "Título del nuevo tour *",
      "track-new-tour-description": "Descripción del nuevo tour",
      "track-tour-title-placeholder": "Título del tour",
      "track-new-tour-description-placeholder": "Descripción del tour (opcional)",
      "track-create-tour": "Crear tour",
      "track-location": "Ubicación",
      "track-title": "Título *",
      "track-title-placeholder": "Título de la parada",
      "track-text-content-full-placeholder": "Escribe lo que quieres decir en esta parada...",
      "track-error-select-audio": "Selecciona un archivo de audio (MP3, M4A, WAV, etc.)",
      "track-error-audio-duration": "No se pudo leer la duración del archivo de audio",
      "track-error-title-required": "El título es obligatorio",
      "track-error-valid-latitude": "Se requiere una latitud válida (-90 a 90)",
      "track-error-valid-longitude": "Se requiere una longitud válida (-180 a 180)",
      "track-error-audio-or-text": "Añade un archivo de audio o contenido de texto",
      "track-error-text-or-audio": "Añade contenido de texto o un archivo de audio",
      "track-error-sequence": "La secuencia debe ser 0 o mayor",
      "track-error-get-upload-url": "No se pudo obtener la URL de subida",
      "track-error-upload-audio": "No se pudo subir el archivo de audio",
      "track-error-create-stop": "No se pudo crear la parada",
      "track-error-update-stop": "No se pudo actualizar la parada",
      "track-error-save-stop": "No se pudo guardar la parada",
      "track-error-read-audio-file": "No se pudo leer el archivo de audio. Prueba con otro archivo.",
      "track-error-enter-tour-title": "Introduce un título para el tour",
      "track-error-create-tour": "No se pudo crear el tour",
      "track-error-select-tour": "Selecciona un tour o crea uno nuevo",
      "track-error-title": "Introduce un título",
      "track-error-content": "Proporciona audio o contenido de texto",
      "track-error-duration": "No se pudo leer la duración del audio. Elige otro archivo de audio.",
      "track-error-upload-track": "No se pudo subir la pista. Inténtalo de nuevo.",

      "sharing-title": "Gestionar uso compartido del tour",
      "sharing-info": "Comparte este tour privado con usuarios específicos introduciendo su correo electrónico. Podrán ver y reproducir el tour una vez compartido.",
      "sharing-user-email": "Correo del usuario",
      "sharing": "Compartiendo...",
      "share": "Compartir",
      "sharing-shared-with": "Compartido con ({{count}})",
      "sharing-empty": "Este tour aún no se ha compartido con nadie.",
      "sharing-date": "Compartido {{date}}",
      "sharing-remove-access": "Eliminar acceso",
      "sharing-remove": "Eliminar",

      "schedule-title": "Programar Tour",
      "schedule-add-date": "Añadir Fecha",
      "schedule-date": "Fecha y Hora",
      "schedule-capacity": "Plazas Disponibles",
      "schedule-no-dates": "No hay fechas programadas. ¡Añade tu primera fecha disponible!",
      "schedule-add-new-date": "Añadir nueva fecha",
      "schedule-date-only": "Fecha",
      "schedule-time": "Hora",
      "schedule-upcoming-dates": "Próximas fechas",
      "schedule-past-dates": "Fechas pasadas",
      "schedule-booked": "{{booked}} / {{capacity}} reservadas",
      "schedule-attended": "{{booked}} / {{capacity}} asistieron",
      "schedule-delete-date": "Eliminar esta fecha",
      "schedule-select-date-error": "Selecciona una fecha",
      "schedule-future-date-error": "Selecciona una fecha y hora futuras",
      "schedule-tour-fallback": "Tour",

      "brochure-share-world": "Comparte tu mundo",
      "brochure-subtitle": "Convierte tu conocimiento local en experiencias inolvidables para viajeros de todo el mundo.",
      "brochure-publish-anytime": "Publica cuando quieras",
      "brochure-publish-anytime-text": "Crea tours y añade paradas cuando quieras. Actualiza el contenido a medida que tu ciudad cambia.",
      "brochure-earn-money": "Gana dinero",
      "brochure-earn-money-text": "Gana regalías cuando los oyentes pasan tiempo con tus tours.",
      "brochure-meet-people": "Conoce personas",
      "brochure-meet-people-text": "Conecta con viajeros de todo el mundo y comparte tu pasión por tu ciudad.",
      "brochure-how-it-works": "Cómo funciona",
      "brochure-step-profile": "Crea tu perfil",
      "brochure-step-profile-text": "Regístrate y cuéntales a los visitantes sobre ti, tu historia y lo que te hace único.",
      "brochure-step-tours": "Diseña tus tours",
      "brochure-step-tours-text": "Crea tours que muestren lo que amas de tu ciudad. Añade fotos, descripciones y paradas de audio.",
      "brochure-step-grow": "Publica y crece",
      "brochure-step-grow-text": "Publica tu tour y sigue mejorándolo con el tiempo mientras los oyentes exploran tu ciudad.",
      "brochure-ready": "¿Listo para comenzar?",
      "brochure-or": "o",
      "brochure-go-dashboard": "Ir al panel",
      "brochure-create-account": "Crea una cuenta para iniciar tu camino como guía.",
      "brochure-sign-up-now": "Regístrate ahora",
      "brochure-promise": "Nuestra promesa",
      "brochure-no-hidden-fees": "Sin cargos ocultos",
      "brochure-no-hidden-fees-text": "Acceso simple por suscripción para oyentes y pagos de regalías transparentes para guías.",
      "brochure-control": "Tú tienes el control",
      "brochure-control-text": "Publica tours, actualiza contenido cuando quieras y construye tu audiencia.",
      "brochure-easy-tools": "Herramientas fáciles",
      "brochure-easy-tools-text": "Herramientas simples para publicar tours, gestionar paradas y hacer crecer tu audiencia.",
      "brochure-global-reach": "Alcance global",
      "brochure-global-reach-text": "Conecta con viajeros que buscan experiencias locales auténticas.",

      "about-intro": "¡Hola! Me llamo Vallard y vivo en el área de Portland, Oregón. Estoy felizmente casado y tengo 4 hijos increíbles.",
      "about-trip": "Hice mi primer viaje solo a los 18 años, a Israel, y viví varios meses en un kibutz. Fue la primera vez que me aventuré por mi cuenta. Como tú, amo viajar. Me he dado cuenta de que lo que más amo de viajar es crear conexiones con otras personas. Quiero construir una plataforma que mejore la experiencia de los viajeros y de las personas que viven en los lugares que visitan.",
      "about-connect-heading": "Conéctate globalmente conectando localmente.",
      "about-social-issues": "Hay dos problemas sociales que espero ayudar a resolver con esta plataforma.",
      "about-loneliness-title": "Soledad",
      "about-loneliness-text": "La Organización Mundial de la Salud (OMS) afirmó que una de cada cuatro personas experimenta aislamiento social y que uno de cada seis adolescentes está socialmente aislado y solo, aunque probablemente sea una subestimación. Nuestra investigación ha encontrado una tendencia creciente de viajeros solos, en su mayoría mujeres. Creemos que las conexiones con otras personas son clave para la felicidad y queremos ayudar a que las personas creen esas conexiones. La OMS también afirmó que la conexión social tiene beneficios profundos para mejorar la salud, la educación y la economía.",
      "about-source": "Fuente",
      "about-good-life": "Hace poco leí The Good Life de Robert Waldinger y Marc Schulz. En el libro hablan del Estudio de Desarrollo Adulto de Harvard, el estudio más largo que se ha hecho sobre la vida adulta. Descubrieron que las personas más felices y saludables eran las que tenían relaciones más fuertes. Este sitio busca ayudar a crear más conexiones.",
      "about-empower-title": "Impulsar a emprendedores emergentes",
      "about-empower-text": "Hemos visto cómo grandes empresas como Airbnb o Uber se han aprovechado de personas en todo el mundo quedándose con un gran porcentaje de sus ingresos. Estas empresas requieren una inversión inicial que cada vez es más difícil para la mayoría. Las casas y los autos cuestan mucho dinero. Con un negocio basado en tours, las barreras de entrada son muy bajas. Cualquier persona con determinación y ganas puede tener la flexibilidad de dirigir su propio negocio. Así quiero llevar libertad económica a personas de todo el mundo. También creo que una persona local puede ofrecer una mejor experiencia que una gran corporación.",
      "about-travel-peace": "Como viajero de toda la vida y alguien que ha vivido en muchos lugares, he creado conexiones reales y duraderas con personas de todo el mundo, incluso cuando el contacto fue breve. Viajar ayuda a eliminar el miedo, el prejuicio y el odio. Es la mejor educación que una persona puede tener para detener guerras y traer más paz al mundo.",
      "about-money-heading": "Cómo gana dinero Torgyd",
      "about-money-text": "Este proyecto está evolucionando hacia una experiencia de tours de audio basada en suscripción. El objetivo es facilitar descubrir y escuchar tours basados en la ubicación, asegurando que los guías reciban un pago justo.",
      "about-listeners": "Los oyentes se suscriben mensualmente para tener acceso ilimitado a tours de audio.",
      "about-guides": "Los guías ganan regalías según el tiempo de escucha, con pagos al estilo Spotify.",
      "about-eatwith": "Eat with the Natives es un servicio experimental gratuito que me parece interesante y que quería probar.",
      "about-subscription": "En el modelo de suscripción, la plataforma se mantiene simple: los usuarios pagan una suscripción, los guías reciben pago según la escucha y no hay precio por tour individual.",

      "safety-title": "Seguridad en Torgyd: nuestra prioridad",
      "safety-intro": "En Torgyd nos comprometemos a crear un entorno seguro y confiable para que turistas y personas locales se conecten y compartan experiencias únicas. Tu seguridad es nuestra máxima prioridad, y animamos a todos los usuarios a priorizarla en cada interacción.",
      "safety-confidence-heading": "Conecta con confianza",
      "safety-social-title": "Perfiles de redes sociales:",
      "safety-social-text": "Todas las conexiones en nuestra plataforma se inician a través de redes sociales, lo que aporta una capa de transparencia. Animamos a los usuarios a revisar cuidadosamente los perfiles sociales antes de aceptar reunirse. Este paso es clave para establecer confianza y comodidad mutua.",
      "safety-communication-title": "Comunicación transparente:",
      "safety-communication-text": "La comunicación clara y abierta es esencial. Habla de tus planes en detalle, comparte expectativas y no dudes en hacer preguntas. Informa siempre a alguien de confianza sobre tus planes y dónde estarás.",
      "safety-meeting-heading": "Reunirse con seguridad",
      "safety-public-title": "Elige lugares públicos:",
      "safety-public-text": "Para todas las reuniones, ya sea para tomar café, comer o beber algo, elige siempre lugares públicos y concurridos. Restaurantes, cafeterías y bares en zonas céntricas son ideales. Estos entornos no solo ayudan a garantizar la seguridad, también contribuyen a una experiencia relajada y agradable.",
      "safety-locale-title": "Infórmate sobre el lugar:",
      "safety-locale-text": "Familiarízate con el lugar de la reunión de antemano. Conoce la seguridad general de la zona, las normas culturales y las opciones de transporte público. Si eres turista, tómate el tiempo de investigar; si eres local, elige un lugar donde te sientas cómodo y comparte cualquier información relevante con tu invitado.",
      "safety-sober-title": "Mantente sobrio y alerta:",
      "safety-sober-text": "Mientras disfrutas el momento, es importante mantenerte alerta y en control de la situación. Limita el consumo de alcohol y evita sustancias que puedan afectar tu juicio.",
      "safety-emergency-heading": "En caso de emergencia",
      "safety-emergency-title": "Contactos de emergencia:",
      "safety-emergency-text": "Ten siempre una lista de contactos de emergencia, incluidas autoridades locales y tu embajada si eres turista. No dependas únicamente de tu anfitrión o invitado para esta información.",
      "safety-instincts-title": "Confía en tus instintos:",
      "safety-instincts-text": "Si en cualquier momento te sientes incómodo o inseguro, confía en tus instintos y no dudes en terminar la reunión de forma educada pero firme. Tu seguridad es más importante que las cortesías sociales.",
      "safety-after-heading": "Después de la reunión",
      "safety-feedback-title": "Deja comentarios y reseñas:",
      "safety-feedback-text": "Después de la reunión, te animamos a dejar comentarios. Tus reseñas nos ayudan a mantener una comunidad segura y ayudan a otros a tomar decisiones informadas.",
      "safety-closing": "La seguridad es una responsabilidad compartida y, siguiendo estas pautas, creemos que puedes tener experiencias agradables y memorables a través de Torgyd. Si tienes alguna inquietud o necesitas ayuda, nuestro equipo de soporte siempre está aquí para ayudarte.",

      "privacy-title": "Privacidad",
      "privacy-text": "Los datos que me das no los comparto.\nNo me los llevo a ningún lado.\nNo los vendo en una caja.\nNo los vendo a nadie.\nNo rastreo los clics que haces.\nNo rastreo los pasos que das.\nFacebook, Google y todos sus rastreadores\npueden quedarse fuera de aquí.\nNo te rastreo aquí ni allá.\nNo te rastreo en ningún lugar.",

      "admin-summary": "Usuarios: {{users}} · Guías: {{guides}} · Tours: {{tours}}",
      "refresh": "Actualizar",
      "admin-signin-required": "Inicia sesión para acceder a las herramientas de administración.",
      "admin-access-denied": "Acceso denegado. Esta página es solo para administradores.",
      "error": "Error",
      "admin-all-users": "Todos los usuarios",
      "admin-search-users": "Buscar por correo o id...",
      "admin-email": "Correo",
      "admin-signed-up": "Registrado",
      "admin-superuser": "Superusuario",
      "admin-active": "Activo",
      "admin-verified": "Verificado",
      "yes": "Sí",
      "no": "No",
      "admin-no-users": "No se encontraron usuarios.",
      "admin-all-guides": "Todos los guías",
      "admin-search-guides": "Buscar por nombre, correo, id de usuario o id...",
      "admin-guide": "Guía",
      "admin-created": "Creado",
      "admin-user": "usuario",
      "admin-no-guides": "No se encontraron guías.",
      "admin-all-tours": "Todos los tours",
      "admin-search-tours": "Buscar por título o id...",
      "admin-title": "Título",
      "admin-view": "Ver",
      "admin-open": "Abrir",
      "admin-no-tours": "No se encontraron tours.",

      "footer-about": "Acerca de",
      "footer-links": "Enlaces",
      "footer-safety": "Seguridad",
      "footer-privacy": "Privacidad",
      "footer-socials": "Conectar",
      "footer-tagline": "Experiencias locales auténticas, un tour a la vez.",
      "footer-rights": "Todos los derechos reservados."
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
